<template>
    <div @click="_down" class="upload-kyb">
        <div class="icon-name">
            <img :src="iconObj.icon" alt="" />
            {{iconObj.title}}
        </div>
        <span>{{ iconObj.desc }}</span>
    </div>
</template>

<script>
    import {CheckLibs} from '@digital-supply-chain/module'

  export default {
    data() {
      return {};
    },
    computed: {
        iconObj() {
            let icon = `${DomainService.PublicPath}resource/images/icon/dagongcs.png`;
            let title = '大工程师';
            if (CheckLibs.isGreatCraftsman() || CheckLibs.isGreatCraftsmanEnt()) {
                icon = `${DomainService.PublicPath}resource/images/icon/daguozz.png`;
                title = '大国工匠'
            }
            return { icon, title, desc: `点击下载${title}客户端安装软件` }
        }
    },
    methods: {
        _down() {
            if (location.origin.includes('global-dsc.')) {
                window.open('https://down.global-dsc.cn/Release/dggj/dggj.exe');
                return false;
            }
            window.open('https://down.global-dsc.cn/Release/bige/BigEInstall_Release.exe');
        }
    }
  };
</script>

<style lang="less" scoped>
    .use-kyb-dialog{
        .text-content{
            font-size: 16px;
            line-height: 30px;
        }
        /deep/ .el-dialog{
            background: #ecf5ff;
            border: 1px solid #b3d8ff;
            border-radius: 28px;
        }
        /deep/ .el-dialog__header{
            padding: 0;
        }
        /deep/ .el-dialog__body{
            padding-bottom: 0;
        }
    }
    .upload-kyb{
        position: absolute;
        right: -72px;
        top: 0;
        font-size: 12px;
        color: #0989C5;
        line-height: 18px;
        color: #0989c5;
        z-index: 1000;
        cursor: pointer;
        outline: none;
        text-align: center;
        img{
            width: 30px;
            height: 30px;
            position: absolute;
            left: 0;
            top: 0;
        }
        .icon-name{
            width: 120px;
            line-height: 30px;
            color: #dc0000;
            font-size: 20px;
            font-weight: bold;
            padding-left: 36px;
            margin: 0 auto;
            margin-bottom: 4px;
            position: relative;
        }
    }
    .dialog-footer{
        text-align: center;
        width: 100%;
        display: block;
    }
</style>
